import Rating from '@mui/material/Rating';
import Star from '../../../assets/SVGComponents/iconStar';

import { CSSProperties } from 'react';

const ScoreStars = ({ value, styles = {}, strokeColor = "white" }: { value: number; styles?: CSSProperties; strokeColor?: string; }) => {
  return (
    <Rating
      className="animated-text"
      style={{ ...styles }}
      value={value / 20}
      readOnly
      size="large"
      precision={0.5}
      emptyIcon={<Star fillColor='transparent' strokeColor={strokeColor} />}
      icon={<Star strokeColor={strokeColor} />}
      sx={{ gap: 0.5 }}
    />
  );
};

export default ScoreStars;
